import React, { useState } from "react";

export default function FormComponent() {
  const [formState, setFormState] = useState({});
  const [file, setFile] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormState({ ...formState, [e.target.name]: e.target.value });
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile && selectedFile.size > 2 * 1024 * 1024) {
      alert("Plik jest zbyt duży. Maksymalna wielkość to 2MB.");
      return;
    }
    setFile(selectedFile);
  };

  const redirectUser = () => {
    window.location.href = "/sukces/";
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (file && file.size > 2 * 1024 * 1024) {
      alert("Plik jest zbyt duży. Maksymalna wielkość to 2MB.");
      return;
    }

    setSubmitting(true);

    const formElement = e.target;
    const formData = new FormData(formElement);

    // Send to Slack endpoint first
    try {
      const slackResponse = await fetch(
        "https://opengraf.pl/wp-json/custom/v1/send-to-slack",
        {
          method: "POST",
          body: formData,
        }
      );

      if (!slackResponse.ok) {
        throw new Error("Błąd wysyłania do Slacka");
      }

      // After Slack post succeeded, submit form natively to Netlify
      formElement.submit();
      redirectUser();
    } catch (error) {
      alert("Wystąpił błąd przy wysyłaniu do Slacka.");
      console.error(error);
      setSubmitting(false);
    }
  };

  return (
    <div
      id="zamow"
      className="columns is-multiline is-variable is-4 is-vcentered"
      style={{ padding: "0 5%", marginTop: "75px" }}
    >
      <div className="column is-full-mobile is-half-tablet is-one-third-desktop">
        <form
          name="Kreator-kalendarzy"
          method="POST"
          action="/sukces/" // ✅ Add this
          id="formularz"
          data-netlify="true"
          data-netlify-honeypot="bot-field"
          encType="multipart/form-data"
          onSubmit={handleSubmit}
          className="box px-6 py-5"
          style={{ backgroundColor: "#49C78E", borderRadius: "25px" }}
        >
          {/* Netlify Hidden Fields */}
          <input type="hidden" name="form-name" value="Kreator-kalendarzy" />
          <p hidden>
            <label>
              Don’t fill this out:{" "}
              <input name="bot-field" onChange={handleChange} />
            </label>
          </p>

          <h2 className="title is-3 has-text-weight-bold">
            Prześlij swój projekt
          </h2>

          <div className="field">
            <label className="label">Imię i nazwisko*:</label>
            <div className="control">
              <input
                className="input"
                type="text"
                name="imie"
                required
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="field">
            <label className="label">Adres E-mail*:</label>
            <div className="control">
              <input
                className="input"
                type="email"
                name="adres-email"
                required
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="field">
            <label className="label">Numer telefonu:</label>
            <div className="control">
              <input
                className="input"
                type="tel"
                name="numer-telefonu"
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="field">
            <label className="label">Ilość kalendarzy*:</label>
            <div className="control">
              <input
                className="input"
                type="number"
                name="ilosc-kalendarzy"
                min="30"
                required
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="field">
            <label className="label">Załącz plik z kreatora:</label>
            <div className="control">
              <input
                id="file"
                name="plik"
                type="file"
                accept="application/pdf"
                style={{
                  position: "absolute",
                  width: "1px",
                  height: "1px",
                  padding: 0,
                  margin: "-1px",
                  overflow: "hidden",
                  clip: "rect(0, 0, 0, 0)",
                  border: 0,
                }}
                onChange={handleFileChange}
              />
              <label
                htmlFor="file"
                className="button is-light is-rounded"
                style={{ cursor: "pointer" }}
              >
                Wybierz plik
              </label>
            </div>

            {file && (
              <p className="has-text-white mt-2" style={{ fontSize: "0.9rem" }}>
                Wybrany plik:{" "}
                <strong style={{ color: "white" }}>{file.name}</strong>
              </p>
            )}
            <p className="help is-white" style={{ fontSize: "12px" }}>
              Maksymalna wielkość pliku to{" "}
              <strong style={{ color: "white" }}>2MB</strong>.
            </p>
          </div>

          {/* reCAPTCHA 
          <div data-netlify-recaptcha="true" className="mb-4" />
          */}

          <div className="field">
            <label className="label">Wiadomość*:</label>
            <div className="control">
              <textarea
                className="textarea"
                name="wiadomosc"
                rows={5}
                required
                onChange={handleChange}
              ></textarea>
            </div>
          </div>

          <div className="field" style={{ marginTop: "-20px" }}>
            <div className="control">
              <label className="checkbox">
                <input
                  type="checkbox"
                  name="privacy"
                  required
                  onChange={handleChange}
                  className="mr-2"
                />
                Wyrażam zgodę na przetwarzanie moich danych zgodnie z naszą{" "}
                <a
                  href="https://artopen.pl/polityka-prywatnosci/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  polityką prywatności
                </a>
                .
              </label>
            </div>
          </div>

          <div className="field mt-2">
            <div className="control">
              <button
                type="submit"
                className="button is-warning is-rounded has-text-weight-bold"
                disabled={submitting}
              >
                {submitting ? "Wysyłanie..." : "Wyślij"}
              </button>
            </div>
          </div>
        </form>
      </div>

      <div className="column is-full-mobile is-half-tablet is-two-thirds-desktop">
        <figure className="image">
          <img
            src="/assets/images/telka.png"
            alt="Form visual"
            style={{ width: "100%", height: "auto" }}
          />
        </figure>
      </div>
    </div>
  );
}
